<template lang="pug">
  v-list
    v-subheader Выберите необходимый шаблон для создания новой секции
    v-list-item(v-for="([key, item], idx) in Object.entries(pickSectionLists[defaultType])")
      v-list-item-avatar
        v-avatar(color="secondary"): strong.white--text {{ idx+1 }}
      v-list-item-content
        v-card(
          @click="pick(key)"
        ).sdo-card
          v-card-text
            v-img(
              v-if="item.img"
              :src="item.img"
            )
            .text-center {{ item.name }}
              .grey--text(v-if="item.description") В этом блоке будут выведены все темы курса
</template>

<script>
import {
  textDescription,
  topAvatar,
  leftAvatar,
  questions,
  progress,
  units,
  pickSectionLists,
} from './templates';

export default {
  props: {
    defaultType: { type: String, default: 'course' },
  },
  data: () => ({
    pickSectionLists,
    templates: {
      textDescription,
      topAvatar,
      leftAvatar,
      questions,
      progress,
      units,
    },
  }),
  methods: {
    pick(templateKey) {
      this.$emit('pick', this.pickSectionLists[this.defaultType][templateKey].component);
    },
  },
};
</script>
